import { Card } from '@mui/material'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import AssetPreviewDisplay from '../assetpreviewdisplay/AssetPreviewDisplay'
import { CollectionTypographyHome } from '../collectiontypography/CollectionTypographyHome'
import Link from '../common/util/input/Link'
import { renderProgressBar } from '../drops/DropProgressBar'

export const TeaserCardHome = ({
    image,
    video,
    thumbnail,
    author,
    name,
    collectionImage,
    collectionThumbnail,
    verified,
    link,
    index,
    price,
    soldOut,
    numClaimed,
    maxClaimable,
    isPfp,
    isBeingDragged,
}) => {
    const { t } = useTranslation('common')
    return (
        <Card
            className={cn(
                'group min-w-[280px] w-[280px] h-full rounded-lg  bg-zinc-300   dark:!bg-paper ',
                '',
            )}
            tabIndex={index}
        >
            {renderProgressBar(numClaimed, maxClaimable)}
            {isPfp ? (
                <div
                    className={cn(
                        'text-primary text-3xl sm:text-sm lg:text-2xl font-extrabold',
                        'absolute top-4 left-2 -rotate-9',
                        'border-primary p-1 rounded-md border-4  z-50 text-center whitespace-nowrap',
                    )}
                >
                    {t('drops.generative_drop')}
                </div>
            ) : null}
            {soldOut && (
                <div
                    className={cn(
                        'text-red-600 text-3xl sm:text-sm lg:text-2xl font-extrabold uppercase',
                        'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rotate-12',
                        'border-red-600 p-2 rounded-md border-4 bg-red-100/90 z-50 text-center whitespace-nowrap',
                    )}
                >
                    {t('drops.sold_out')}
                </div>
            )}
            <Link
                href={link}
                className={
                    'h-[280px] dark:!bg-black bg-white flex items-center justify-center w-full overflow-hidden'
                }
            >
                <AssetPreviewDisplay
                    className="w-full h-full my-auto"
                    asset={{
                        image: thumbnail ? thumbnail : image,
                        video: thumbnail ? null : video,
                    }}
                    previewDuration={0}
                    grayScale={soldOut}
                    fetchPriority={'high'}
                    imgClassName={' cursor-pointer w-full object-contain'}
                />
            </Link>
            <Link
                href={link}
                className={cn(
                    ' h-[111px] px-4 py-2  w-full',
                    ' dark:!bg-paper bg-zinc-200   text-center z-100',
                )}
                inactive={isBeingDragged}
            >
                <CollectionTypographyHome
                    author={author}
                    collectionImage={collectionImage}
                    collectionThumbnail={collectionThumbnail}
                    verified={verified}
                    name={name}
                />

                <div>
                    {/* {isPfp ? (
                        <Typography
                            variant="body1"
                            fontWeight="bold"
                            color="text-white dark:!text-black"
                        >
                            PFP Drop
                        </Typography>
                    ) : null} */}
                    <div className="flex items-center justify-between mt-3 ">
                        {price ? (
                            <p className="text-black font-semibold text-sm dark:!text-white">
                                {price}
                            </p>
                        ) : null}

                        {maxClaimable > 0 ? (
                            <p className="text-black font-semibold text-sm dark:!text-white">
                                {`${
                                    maxClaimable - numClaimed
                                } / ${maxClaimable} in stock`}
                            </p>
                        ) : maxClaimable === 0 ? (
                            <p className="text-black font-semibold text-sm dark:!text-white">
                                {`${
                                    maxClaimable - numClaimed
                                } / ${maxClaimable} in stock`}
                            </p>
                        ) : null}
                    </div>
                </div>
            </Link>
        </Card>
    )
}
